<!-- <nav class="navbar navbar-expand-lg tm-block-dark navbar-absolute" color-on-scroll="500">
  <div class="container">
    <img src="./assets/img/cintillo_izq.jpg" alt="Cintillo" class="img-fluid">
    <img src="./assets/img/cintillo_der.jpg" alt="Cintillo" class="img-fluid">
  </div>
</nav> -->

<router-outlet></router-outlet>
